import Slider from '@mui/material/Slider'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'
import { useRef, useState } from 'react'

const CustomSlider = styled(Slider)(({ theme }) => ({
  borderRadius: 5,
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    '&:before': {
      display: 'none',
    },
    '&:after': {
      display: 'none',
    },
  },
  '& .MuiSlider-track': {
    height: 3,
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiSlider-rail': {
    opacity: 0.3,
    backgroundColor: theme.palette.other.grey[40].main,
  },
}))

const SeekBar = ({ sliderProps, containerProps, onSeek, seekbarTimeFormat, value, max }) => {
  const rootRef = useRef()
  const [seekTime, setSeekTime] = useState()
  const [mouseOffsetX, setMouseOffsetX] = useState(0)
  const [thumbHover, setThumbHover] = useState(false)

  const sx = {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    ...(containerProps?.sx || {}),
  }

  return (
    <Box {...containerProps} ref={rootRef} sx={sx}>
      <CustomSlider
        valueLabelDisplay="auto"
        valueLabelFormat={seekbarTimeFormat}
        onChange={() => {
          onSeek(seekTime)
        }}
        value={value}
        max={max}
        onMouseMove={e => {
          const offsetX = Math.max(0, e.nativeEvent.offsetX)
          const fraction = offsetX / rootRef.current.offsetWidth
          setSeekTime(max * fraction)
          setMouseOffsetX(offsetX)
        }}
        onMouseLeave={() => {
          setSeekTime()
        }}
        slotProps={{
          thumb: {
            onMouseEnter: () => {
              setThumbHover(true)
            },
            onMouseLeave: () => {
              setThumbHover(false)
            },
          },
        }}
        {...sliderProps}
      />
      <Tooltip
        PopperProps={{ container: rootRef.current }}
        title={seekbarTimeFormat(seekTime)}
        arrow
        open={!!seekTime}
        placement="top"
        slotProps={{
          popper: {
            sx: { display: thumbHover ? 'none' : 'block', pointerEvents: 'none !important' },
          },
        }}
      >
        <Box sx={{ pointerEvents: 'none !important', position: 'absolute', left: mouseOffsetX }} />
      </Tooltip>
    </Box>
  )
}

export default SeekBar
